<script>
</script>

<div class="flex flex-row justify-evenly items-center dark:text-white">
    <div class="flex flex-col justify-center items-center">
        <div class="text-8xl">
            <i class="lab la-apple" />
        </div>
        <div>Downloads</div>
        <div class="hover:underline">
            <a href="../financer/macos/Financer_0.1.0_aarch64.dmg"
                >Financer.dmg</a
            >
        </div>
    </div>
    <div class="flex flex-col justify-center items-center">
        <div class="text-8xl">
            <i class="lab la-linux" />
        </div>
        <div>Coming Soon!</div>
        <!-- <div class="hover:underline">
            <a href="../financer/linux/financer_0.1.0_amd64.deb">Financer.deb</a
            >
        </div>
        <div class="hover:underline">
            <a href="../financer/linux/financer_0.1.0_amd64.AppImage"
                >Financer.AppImage</a
            >
        </div> -->
    </div>
    <div class="flex flex-col justify-center items-center">
        <div class="text-8xl">
            <i class="lab la-windows" />
        </div>
        <div>Coming soon!</div>
        <div class="hover:underline">
        </div>
    </div>
</div>
